import { useSelector } from 'react-redux'

import { dispatch } from 'store'
import { aiImageThunks } from 'store/features/aiImage/thunks'
import { aiImageSelectors } from 'store/features/aiImage/selectors'
import { downloadMedia } from 'utils'

import { editorThunks } from 'store/features/editor/thunks'
import { aiVideoThunks } from 'store/features/aiVideo/thunks'
import { SUB_SIDEBAR_KEYS } from 'consts/sidebar'
import { IReferenceImage } from 'store/types/aiImage'
import { useCallback } from 'react'
import { AI_GENERATE_TAB_KEY, AI_HISTORY_TAB_KEY } from '../consts'

const switchToGenerateTab = () => {
  dispatch(editorThunks.setAsideOverlayContent(null))
  dispatch(editorThunks.setActiveSidebarTab(SUB_SIDEBAR_KEYS.AI_IMAGE))
  dispatch(aiImageThunks.setActiveTab(AI_GENERATE_TAB_KEY))
}

const switchToHistoryTab = () => {
  dispatch(editorThunks.setActiveSidebarTab(SUB_SIDEBAR_KEYS.AI_IMAGE))
  dispatch(aiImageThunks.setActiveTab(AI_HISTORY_TAB_KEY))
  dispatch(editorThunks.setAsideOverlayContent(null))
}

const useActions = () => {
  const formData = useSelector(aiImageSelectors.generateForm)
  const activeMedia = useSelector(aiImageSelectors.targetMediaItem)
  const { width, height, images, id } = formData
  const aiImagePath = images[0]?.filePath || ''

  const handleUseAsReference = useCallback(() => {
    switchToGenerateTab()

    const referenceImage: IReferenceImage = {
      id,
      url: aiImagePath || '',
      thumbnailUrl: images[0].thumbnailPath || aiImagePath || '',
      width,
      height
    }

    dispatch(aiImageThunks.replaceReferenceImages([referenceImage]))
    dispatch(aiImageThunks.setTargetMediaItemId(null))
    dispatch(aiImageThunks.setPrompt(''))
  }, [aiImagePath, images, id, width, height])

  const handleAnimate = useCallback(() => {
    if (!activeMedia?.assetId) return

    dispatch(
      aiVideoThunks.animateAiImage({
        assetId: activeMedia.assetId,
        isAiImage: true,
        mediaItemId: activeMedia?.id,
        duration: activeMedia?.duration
      })
    )
  }, [activeMedia])

  const handleDownload = async () => {
    if (!aiImagePath) return

    await downloadMedia({
      filePath: aiImagePath,
      fileName: `ai-image-${activeMedia?.assetId}`
    })
  }

  const handleVersionHistory = useCallback(() => {
    switchToHistoryTab()
  }, [])

  return {
    handleRegenerate: switchToGenerateTab,
    handleUseAsReference,
    handleAnimate,
    handleDownload,
    handleVersionHistory
  }
}

export default useActions
